// @ts-strict-ignore
import {EntityType} from 'common/report/util/saved-entities/types';
import {ActivityMonitor} from 'common/util/activity-monitor';
import {apiClient} from 'common/util/api-client';
import {PresenceResults} from 'app_api/projects/presence/types';

import {appApiUrl} from '../utils';

function markPresenceView(
  projectId: number,
  entityType:
    | EntityType.Dashboard
    | EntityType.Report
    | EntityType.MetricTree
    | EntityType.Experiment
    | EntityType.FeatureFlag
    | EntityType.HeatMap,
  resourceId: number,
): Promise<PresenceResults> {
  let entityPath = `bookmarks`;
  if (entityType === EntityType.Dashboard) {
    entityPath = `dashboards`;
  } else if (entityType === EntityType.MetricTree) {
    entityPath = `canvases`;
  } else if (entityType === EntityType.Experiment) {
    entityPath = `experiments`;
  } else if (entityType === EntityType.FeatureFlag) {
    entityPath = `feature-flags`;
  } else if (entityType === EntityType.HeatMap) {
    entityPath = `heatmaps`;
  }
  const endpoint = appApiUrl(`${entityPath}/${resourceId}/views`, {projectId});
  return apiClient.post<PresenceResults>(endpoint, {});
}

export const presenceClient = {markPresenceView};

// create an ActivityMonitor instance to send presence requests every 30 minutes when user is active
// TODO(CC) - make this work for canvas
export function getPresenceActivityMonitor({
  projectId,
  entityType,
  resourceId,
  callback,
}: {
  projectId: number;
  entityType:
    | EntityType.Dashboard
    | EntityType.Report
    | EntityType.MetricTree
    | EntityType.Experiment
    | EntityType.FeatureFlag
    | EntityType.HeatMap;
  resourceId: number;
  callback: (results: PresenceResults) => void;
}) {
  async function onActive() {
    const results = await presenceClient.markPresenceView(projectId, entityType, resourceId);
    callback(results);
  }

  return new ActivityMonitor({cooldownMs: 30 * 60 * 1000, onActive, fireImmediately: true});
}
